
<div class="p-2 pb-14 flex-1 h-full  overflow-y-auto">
<div class="p-4 rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 shadow-lg">
    <form [formGroup]="companyForm" (ngSubmit)="onSubmit()">
        <div>
            <h2 class="heading">
                General Information
            </h2>
            <p class="text-sm-light">
                (Read Only)
            </p>
        </div>
        <hr class="my-4 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
        <section class="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
            <div class="space-y-1">
                <label class="subheading">
                    Name
                </label>
                <div class="flex flex-1 gap-2">
                    <div class="flex-1">
                        <input formControlName="name" type="text" value="" readonly />
                    </div>
                    <div class="flex gap-1">
                        <button (click)="setControls('','isName', false)" [ngClass]="{'btn btn-danger': !approvalForm.get('isName')?.value,
                                'btn-outline btn-outline-danger': approvalForm.get('isName')?.value}" class="px-2"
                            type="button">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                class="size-5">
                                <path
                                    d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                            </svg>
                        </button>
                        <button (click)="setControls('','isName', true)" [ngClass]="{'btn btn-success': approvalForm.get('isName')?.value,
                                    'btn-outline btn-outline-success ': !approvalForm.get('isName')?.value}"
                            class="px-2" type="button">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                class="size-5">
                                <path fill-rule="evenodd"
                                    d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                    clip-rule="evenodd" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
            <div class="space-y-1">
                <label class="subheading">
                    Company Name
                </label>
                <div class="flex flex-1 gap-2">
                    <div class="flex-1">
                        <input formControlName="transportationCompanyName" type="text" value="" readonly />
                    </div>
                    <div class="flex gap-1">
                        <button (click)="setControls('','isTransportationCompanyName', false)"
                            [ngClass]="{'btn btn-danger': !approvalForm.get('isTransportationCompanyName')?.value,
                                 'btn-outline btn-outline-danger': approvalForm.get('isTransportationCompanyName')?.value}" class="px-2" type="button">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                class="size-5">
                                <path
                                    d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                            </svg>
                        </button>
                        <button (click)="setControls('','isTransportationCompanyName', true)"
                            [ngClass]="{'btn btn-success': approvalForm.get('isTransportationCompanyName')?.value,
                                  'btn-outline btn-outline-success ': !approvalForm.get('isTransportationCompanyName')?.value}" class="px-2" type="button">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                class="size-5">
                                <path fill-rule="evenodd"
                                    d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                    clip-rule="evenodd" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
            <ng-container formGroupName="address">
                <div class="space-y-1">
                    <label class="subheading">
                        Address
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <div>
                                <input formControlName="name" type="text"
                                    value="12804 Willow Point Dr, Fredericksburg, VA 22408, USA" readonly />
                            </div>
                        </div>
                        <div class="flex gap-1">
                            <button (click)="setControls('address','isName', false)" [ngClass]="{'btn btn-danger': !approvalForm.get('address.isName')?.value,
                                        'btn-outline btn-outline-danger': approvalForm.get('address.isName')?.value}"
                                class="px-2" type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path
                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                </svg>
                            </button>
                            <button (click)="setControls('address','isName', true)"
                                [ngClass]="{'btn btn-success': approvalForm.get('address.isName')?.value,
                                        'btn-outline btn-outline-success ': !approvalForm.get('address.isName')?.value}" class="px-2" type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path fill-rule="evenodd"
                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                        clip-rule="evenodd" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        City
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="city" type="text" value="Fredricksburg" readonly />
                        </div>
                        <div class="flex gap-1">
                            <button (click)="setControls('address','isCity', false)" [ngClass]="{
                             'btn btn-danger': !approvalForm.get('address.isCity')?.value, 
                                'btn-outline btn-outline-danger': approvalForm.get('address.isCity')?.value
                                        }" class="px-2" type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path
                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                </svg>
                            </button>
                            <button (click)="setControls('address','isCity', true)" [ngClass]="{'btn btn-success': approvalForm.get('address.isCity')?.value, 
                                    'btn-outline btn-outline-success': !approvalForm.get('address.isCity')?.value }"
                                class="px-2" type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path
                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                        clip-rule="evenodd" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        State
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <div>
                                <input formControlName="state" type="text"
                                    value="12804 Willow Point Dr, Fredericksburg, VA 22408, USA" readonly />
                            </div>
                        </div>
                        <div class="flex gap-1">
                            <button (click)="setControls('address','isState', false)" [ngClass]="{'btn btn-danger': !approvalForm.get('address.isState')?.value,
                                'btn-outline btn-outline-danger': approvalForm.get('address.isState')?.value}"
                                class="px-2" type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path
                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                </svg>
                            </button>
                            <button (click)="setControls('address','isState', true)"
                                [ngClass]="{'btn btn-success': approvalForm.get('address.isState')?.value,
                                            'btn-outline btn-outline-success ': !approvalForm.get('address.isState')?.value}" class="px-2" type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path fill-rule="evenodd"
                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                        clip-rule="evenodd" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </ng-container>
            <div class="space-y-1">
                <label class="subheading">
                    Office Phone Number
                </label>
                <div class="flex flex-1 gap-2">
                    <div class="flex-1">
                        <input formControlName="phoneNumber" type="tel" value="814 718 0908" readonly />
                    </div>
                    <div class="flex gap-1">
                        <button (click)="setControls('','isPhoneNumber', false)" [ngClass]="{'btn btn-danger': !approvalForm.get('isPhoneNumber')?.value,
                                       'btn-outline btn-outline-danger': approvalForm.get('isPhoneNumber')?.value}"
                            class="px-2" type="button">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                class="size-5">
                                <path
                                    d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                            </svg>
                        </button>
                        <button (click)="setControls('','isPhoneNumber', true)" [ngClass]="{'btn btn-success': approvalForm.get('isPhoneNumber')?.value,
                                     'btn-outline btn-outline-success ': !approvalForm.get('isPhoneNumber')?.value}"
                            class="px-2" type="button">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                class="size-5">
                                <path fill-rule="evenodd"
                                    d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                    clip-rule="evenodd" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
            <div class="space-y-1">
                <label class="subheading">
                    Secondary Phone Number
                </label>
                <div class="flex flex-1 gap-2">
                    <div class="flex-1">
                        <input formControlName="secondaryPhoneNumber" type="tel" value="814 718 0909" readonly />
                    </div>
                    <div class="flex gap-1">
                        <button (click)="setControls('','isSecondaryPhoneNumber', false)" [ngClass]="{'btn btn-danger': !approvalForm.get('isSecondaryPhoneNumber')?.value,
                             'btn-outline btn-outline-danger': approvalForm.get('isSecondaryPhoneNumber')?.value}"
                            class="px-2" type="button">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                class="size-5">
                                <path
                                    d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                            </svg>
                        </button>
                        <button (click)="setControls('','isSecondaryPhoneNumber', true)"
                            [ngClass]="{'btn btn-success': approvalForm.get('isSecondaryPhoneNumber')?.value,
                                 'btn-outline btn-outline-success ': !approvalForm.get('isSecondaryPhoneNumber')?.value}" class="px-2" type="button">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                class="size-5">
                                <path fill-rule="evenodd"
                                    d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                    clip-rule="evenodd" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
            <div class="space-y-1">
                <label class="subheading">
                    Email
                </label>
                <div class="flex flex-1 gap-2">
                    <div class="flex-1">
                        <input formControlName="email" type="email" value="zain.qa@yamsol.com" readonly />
                    </div>
                    <div class="flex gap-1">
                        <button (click)="setControls('','isEmail', false)" [ngClass]="{'btn btn-danger': !approvalForm.get('isEmail')?.value,
                                                 'btn-outline btn-outline-danger': approvalForm.get('isEmail')?.value}"
                            class="px-2" type="button">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                class="size-5">
                                <path
                                    d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                            </svg>
                        </button>
                        <button (click)="setControls('','isEmail', true)" [ngClass]="{'btn btn-success': approvalForm.get('isEmail')?.value,
                             'btn-outline btn-outline-success ': !approvalForm.get('isEmail')?.value}" class="px-2"
                            type="button">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                class="size-5">
                                <path fill-rule="evenodd"
                                    d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                    clip-rule="evenodd" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
            <div class="space-y-1">
                <label class="subheading">
                    Service
                </label>
                <div class="flex flex-1 gap-2">
                    <div class="flex-1">
                        <input formControlName="provideService" type="text" readonly />
                    </div>
                    <div class="flex gap-1">
                        <button (click)="setControls('','isProvideService', false)" [ngClass]="{'btn btn-danger': !approvalForm.get('isProvideService')?.value,
                                     'btn-outline btn-outline-danger': approvalForm.get('isProvideService')?.value}"
                            class="px-2" type="button">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                class="size-5">
                                <path
                                    d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                            </svg>
                        </button>
                        <button (click)="setControls('','isProvideService', true)" [ngClass]="{'btn btn-success': approvalForm.get('isProvideService')?.value,
                                 'btn-outline btn-outline-success ': !approvalForm.get('isProvideService')?.value}"
                            class="px-2" type="button">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                class="size-5">
                                <path fill-rule="evenodd"
                                    d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                    clip-rule="evenodd" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
            <div class="space-y-1">
                <label class="subheading">
                    Timezone
                </label>
                <div class="flex flex-1 gap-2">
                    <div class="flex-1">
                        <input formControlName="timeZone" type="text" readonly />
                    </div>
                    <div class="flex gap-1">
                        <button (click)="setControls('','isTimeZone', false)" [ngClass]="{'btn btn-danger': !approvalForm.get('isTimeZone')?.value,
                             'btn-outline btn-outline-danger': approvalForm.get('isTimeZone')?.value}" class="px-2"
                            type="button">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                class="size-5">
                                <path
                                    d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                            </svg>
                        </button>
                        <button (click)="setControls('','isTimeZone', true)" [ngClass]="{'btn btn-success': approvalForm.get('isTimeZone')?.value,
                                'btn-outline btn-outline-success ': !approvalForm.get('isTimeZone')?.value}"
                            class="px-2" type="button">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                class="size-5">
                                <path fill-rule="evenodd"
                                    d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                    clip-rule="evenodd" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
            <div class="space-y-1">
                <label class="subheading">
                    Company Logo
                </label>
                <div class="flex flex-1 gap-2">
                    <div class="flex-1">
                        <input formControlName="profileImageURL" type="text" readonly />
                    </div>
                    <div class="flex gap-1">
                        <button (click)="setControls('','isProfileImageURL', false)" [ngClass]="{'btn btn-danger': !approvalForm.get('isProfileImageURL')?.value,
                                'btn-outline btn-outline-danger': approvalForm.get('isProfileImageURL')?.value}"
                            class="px-2" type="button">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                class="size-5">
                                <path
                                    d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                            </svg>
                        </button>
                        <button (click)="setControls('','isProfileImageURL', true)" [ngClass]="{'btn btn-success': approvalForm.get('isProfileImageURL')?.value,
                              'btn-outline btn-outline-success ': !approvalForm.get('isProfileImageURL')?.value}"
                            class="px-2" type="button">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                class="size-5">
                                <path fill-rule="evenodd"
                                    d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                    clip-rule="evenodd" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
            <div class="space-y-1">
                <label class="subheading">
                    Hours of Operation
                </label>
                <div class="flex flex-1 gap-2">
                    <div class="flex-1">
                        <input formControlName="hoursofOperation" type="text" readonly />
                    </div>
                    <div class="flex gap-1">
                        <button (click)="setControls('','isHoursofOperation', false)" [ngClass]="{'btn btn-danger': !approvalForm.get('isHoursofOperation')?.value,
                                 'btn-outline btn-outline-danger': approvalForm.get('isHoursofOperation')?.value}"
                            class="px-2" type="button">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                class="size-5">
                                <path
                                    d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                            </svg>
                        </button>
                        <button (click)="setControls('','isHoursofOperation', true)" [ngClass]="{'btn btn-success': approvalForm.get('isHoursofOperation')?.value,
                                'btn-outline btn-outline-success ': !approvalForm.get('isHoursofOperation')?.value}"
                            class="px-2" type="button">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                class="size-5">
                                <path fill-rule="evenodd"
                                    d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                    clip-rule="evenodd" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </section>
        <div class="mt-4">
            <h2 class="heading">
                Owner Information
            </h2>
            <p class="text-sm-light">
                (Read Only)
            </p>
        </div>
        <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
        <section class="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
            <ng-container formGroupName="owner">
                <div class="space-y-1">
                    <label class="subheading">
                        First Name
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="firstName" type="text" readonly />
                        </div>
                        <div class="flex gap-1">
                            <button (click)="setControls('owner','isFirstName', false)" [ngClass]="{'btn btn-danger': !approvalForm.get('owner.isFirstName')?.value,
                                'btn-outline btn-outline-danger': approvalForm.get('owner.isFirstName')?.value}"
                                class="px-2" type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path
                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                </svg>
                            </button>
                            <button (click)="setControls('owner','isFirstName', true)"
                                [ngClass]="{'btn btn-success': approvalForm.get('owner.isFirstName')?.value,
                                            'btn-outline btn-outline-success ': !approvalForm.get('owner.isFirstName')?.value}" class="px-2" type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path fill-rule="evenodd"
                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                        clip-rule="evenodd" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Last Name
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="lastName" type="text" readonly />
                        </div>
                        <div class="flex gap-1">
                            <button (click)="setControls('owner','isLastName', false)"
                                [ngClass]="{'btn btn-danger': !approvalForm.get('owner.isLastName')?.value,
                                            'btn-outline btn-outline-danger': approvalForm.get('owner.isLastName')?.value}" class="px-2" type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path
                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                </svg>
                            </button>
                            <button (click)="setControls('owner','isLastName', true)"
                                [ngClass]="{'btn btn-success': approvalForm.get('owner.isLastName')?.value,
                                      'btn-outline btn-outline-success ': !approvalForm.get('owner.isLastName')?.value}" class="px-2" type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path fill-rule="evenodd"
                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                        clip-rule="evenodd" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Phone Number
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="phoneNumber" type="tel" readonly />
                        </div>
                        <div class="flex gap-1">
                            <button (click)="setControls('owner','isPhoneNumber', false)"
                                [ngClass]="{'btn btn-danger': !approvalForm.get('owner.isPhoneNumber')?.value,
                                      'btn-outline btn-outline-danger': approvalForm.get('owner.isPhoneNumber')?.value}" class="px-2" type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path
                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                </svg>
                            </button>
                            <button (click)="setControls('owner','isPhoneNumber', true)"
                                [ngClass]="{'btn btn-success': approvalForm.get('owner.isPhoneNumber')?.value,
                                         'btn-outline btn-outline-success ': !approvalForm.get('owner.isPhoneNumber')?.value}" class="px-2" type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path fill-rule="evenodd"
                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                        clip-rule="evenodd" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Email
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="email" type="email" readonly />
                        </div>
                        <div class="flex gap-1">
                            <button (click)="setControls('owner','isEmail', false)" [ngClass]="{'btn btn-danger': !approvalForm.get('owner.isEmail')?.value,
                                        'btn-outline btn-outline-danger': approvalForm.get('owner.isEmail')?.value}"
                                class="px-2" type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path
                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                </svg>
                            </button>
                            <button (click)="setControls('owner','isEmail', true)"
                                [ngClass]="{'btn btn-success': approvalForm.get('owner.isEmail')?.value,
                                         'btn-outline btn-outline-success ': !approvalForm.get('owner.isEmail')?.value}" class="px-2" type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path fill-rule="evenodd"
                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                        clip-rule="evenodd" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Driver License
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="driverLicenseImage" type="text" readonly />
                        </div>
                        <div class="flex gap-1">
                            <button (click)="setControls('owner','isDriverLicenseImage', false)"
                                [ngClass]="{'btn btn-danger': !approvalForm.get('owner.isDriverLicenseImage')?.value,
                                 'btn-outline btn-outline-danger': approvalForm.get('owner.isDriverLicenseImage')?.value}" class="px-2" type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path
                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                </svg>
                            </button>
                            <button (click)="setControls('owner','isDriverLicenseImage', true)"
                                [ngClass]="{'btn btn-success': approvalForm.get('owner.isDriverLicenseImage')?.value,
                                         'btn-outline btn-outline-success ': !approvalForm.get('owner.isDriverLicenseImage')?.value}" class="px-2" type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path fill-rule="evenodd"
                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                        clip-rule="evenodd" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <ng-container formGroupName="address">
                    <div class="space-y-1">
                        <label class="subheading">
                            Address
                        </label>
                        <div class="flex flex-1 gap-2">
                            <div class="flex-1">
                                <input formControlName="name" type="text" readonly />
                            </div>
                            <div class="flex gap-1">
                                <button (click)="setControls('owner.address','isName', false)" class="px-2"
                                    type="button"
                                    [ngClass]="{'btn btn-danger': !approvalForm.get('owner.address.isName')?.value,
                                                            'btn-outline btn-outline-danger': approvalForm.get('owner.address.isName')?.value}">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                        class="size-5">
                                        <path
                                            d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                    </svg>
                                </button>
                                <button (click)="setControls('owner.address','isName', true)"
                                    [ngClass]="{'btn btn-success': approvalForm.get('owner.address.isName')?.value,
                                                      'btn-outline btn-outline-success ': !approvalForm.get('owner.address.isName')?.value}" class="px-2" type="button">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                        class="size-5">
                                        <path fill-rule="evenodd"
                                            d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                            clip-rule="evenodd" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="space-y-1">
                        <label class="subheading">
                            City
                        </label>
                        <div class="flex flex-1 gap-2">
                            <div class="flex-1">
                                <input formControlName="city" type="text" readonly />
                            </div>
                            <div class="flex gap-1">
                                <button (click)="setControls('owner.address','isCity', false)" class="px-2"
                                    type="button"
                                    [ngClass]="{'btn btn-danger': !approvalForm.get('owner.address.isCity')?.value,
                                        'btn-outline btn-outline-danger': approvalForm.get('owner.address.isCity')?.value}">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                        class="size-5">
                                        <path
                                            d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                    </svg>
                                </button>
                                <button (click)="setControls('owner.address','isCity', true)"
                                    [ngClass]="{'btn btn-success': approvalForm.get('owner.address.isCity')?.value,
                                             'btn-outline btn-outline-success ': !approvalForm.get('owner.address.isCity')?.value}" class="px-2" type="button">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                        class="size-5">
                                        <path fill-rule="evenodd"
                                            d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                            clip-rule="evenodd" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="space-y-1">
                        <label class="subheading">
                            State
                        </label>
                        <div class="flex flex-1 gap-2">
                            <div class="flex-1">
                                <input formControlName="state" type="text" readonly />
                            </div>
                            <div class="flex gap-1">
                                <button (click)="setControls('owner.address','isState', false)" class="px-2"
                                    type="button"
                                    [ngClass]="{'btn btn-danger': !approvalForm.get('owner.address.isState')?.value,
                                         'btn-outline btn-outline-danger': approvalForm.get('owner.address.isState')?.value}">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                        class="size-5">
                                        <path
                                            d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                    </svg>
                                </button>
                                <button (click)="setControls('owner.address','isState', true)"
                                    [ngClass]="{'btn btn-success': approvalForm.get('owner.address.isState')?.value,
                                         'btn-outline btn-outline-success ': !approvalForm.get('owner.address.isState')?.value}" class="px-2" type="button">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                        class="size-5">
                                        <path fill-rule="evenodd"
                                            d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                            clip-rule="evenodd" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </section>
        <div class="mt-4">
            <h2 class="heading">
                Tax Information
            </h2>
            <p class="text-sm-light">
                (Read Only)
            </p>
        </div>
        <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
        <section class="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
            <ng-container formGroupName="documents">
                <div class="space-y-1">
                    <label class="subheading">
                        HIPAA Training Certificate
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="hIPAATrainingCertificateImage" type="text" value="" readonly />
                        </div>
                        <div class="flex gap-1">
                            <button (click)="setControls('documents','isHIPAATrainingCertificateImage', false)"
                                class="px-2" type="button"
                                [ngClass]="{'btn btn-danger': !approvalForm.get('documents.isHIPAATrainingCertificateImage')?.value,
                                            'btn-outline btn-outline-danger': approvalForm.get('documents.isHIPAATrainingCertificateImage')?.value}">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path
                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                </svg>
                            </button>
                            <button (click)="setControls('documents','isHIPAATrainingCertificateImage', true)"
                                [ngClass]="{'btn btn-success': approvalForm.get('documents.isHIPAATrainingCertificateImage')?.value,
                                        'btn-outline btn-outline-success ': !approvalForm.get('documents.isHIPAATrainingCertificateImage')?.value}"
                                class="px-2" type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path fill-rule="evenodd"
                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                        clip-rule="evenodd" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        HIPAA Training Date
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="hIPAATrainingDate" type="text" value="" readonly />
                        </div>
                        <div class="flex gap-1">
                            <button (click)="setControls('documents','isHIPAATrainingDate', false)" class="px-2"
                                type="button"
                                [ngClass]="{'btn btn-danger': !approvalForm.get('documents.isHIPAATrainingDate')?.value,
                                         'btn-outline btn-outline-danger': approvalForm.get('documents.isHIPAATrainingDate')?.value}">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path
                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                </svg>
                            </button>
                            <button (click)="setControls('documents','isHIPAATrainingDate', true)"
                                [ngClass]="{'btn btn-success': approvalForm.get('documents.isHIPAATrainingDate')?.value,
                                      'btn-outline btn-outline-success ': !approvalForm.get('documents.isHIPAATrainingDate')?.value}" class="px-2" type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path fill-rule="evenodd"
                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                        clip-rule="evenodd" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Fraud, Waste and Abuse Training Certificate
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="fraudWasteAndAbuseCertificateImage" type="text" value="" readonly />
                        </div>
                        <div class="flex gap-1">
                            <button (click)="setControls('documents','isFraudWasteAndAbuseCertificateImage', false)"
                                class="px-2" type="button"
                                [ngClass]="{'btn btn-danger': !approvalForm.get('documents.isFraudWasteAndAbuseCertificateImage')?.value,
                                         'btn-outline btn-outline-danger': approvalForm.get('documents.isFraudWasteAndAbuseCertificateImage')?.value}">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path
                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                </svg>
                            </button>
                            <button (click)="setControls('documents','isFraudWasteAndAbuseCertificateImage', true)"
                                [ngClass]="{'btn btn-success': approvalForm.get('documents.isFraudWasteAndAbuseCertificateImage')?.value,
                                      'btn-outline btn-outline-success ': !approvalForm.get('documents.isFraudWasteAndAbuseCertificateImage')?.value}"
                                class="px-2" type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path fill-rule="evenodd"
                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                        clip-rule="evenodd" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Fraud, Waste and Abuse Training Completion Date
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="fraudWasteAndAbuseCertificateDate" type="text" value="" readonly />
                        </div>
                        <div class="flex gap-1">
                            <button (click)="setControls('documents','isFraudWasteAndAbuseCertificateDate', false)"
                                class="px-2" type="button"
                                [ngClass]="{'btn btn-danger': !approvalForm.get('documents.isFraudWasteAndAbuseCertificateDate')?.value,
                                   'btn-outline btn-outline-danger': approvalForm.get('documents.isFraudWasteAndAbuseCertificateDate')?.value}">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path
                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                </svg>
                            </button>
                            <button (click)="setControls('documents','isFraudWasteAndAbuseCertificateDate', true)"
                                [ngClass]="{'btn btn-success': approvalForm.get('documents.isFraudWasteAndAbuseCertificateDate')?.value,
                                  'btn-outline btn-outline-success ': !approvalForm.get('documents.isFraudWasteAndAbuseCertificateDate')?.value}"
                                class="px-2" type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path fill-rule="evenodd"
                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                        clip-rule="evenodd" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Signed Non-Disclosure Agreement
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="nonDisclosureAgreementImage" type="text" value="" readonly />
                        </div>
                        <div class="flex gap-1">
                            <button (click)="setControls('documents','isNonDisclosureAgreementImage', false)"
                                class="px-2" type="button"
                                [ngClass]="{'btn btn-danger': !approvalForm.get('documents.isNonDisclosureAgreementImage')?.value,
                                      'btn-outline btn-outline-danger': approvalForm.get('documents.isNonDisclosureAgreementImage')?.value}">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path
                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                </svg>
                            </button>
                            <button (click)="setControls('documents','isNonDisclosureAgreementImage', true)"
                                [ngClass]="{'btn btn-success': approvalForm.get('documents.isNonDisclosureAgreementImage')?.value,
                                     'btn-outline btn-outline-success ': !approvalForm.get('documents.isNonDisclosureAgreementImage')?.value}" class="px-2" type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path fill-rule="evenodd"
                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                        clip-rule="evenodd" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Signed Transportation Provider Agreement
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="transportationProviderAgreementImage" type="text" value=""
                                readonly />
                        </div>
                        <div class="flex gap-1">
                            <button (click)="setControls('documents','isTransportationProviderAgreementImage', false)"
                                class="px-2" type="button"
                                [ngClass]="{'btn btn-danger': !approvalForm.get('documents.isTransportationProviderAgreementImage')?.value,
                                        'btn-outline btn-outline-danger': approvalForm.get('documents.isTransportationProviderAgreementImage')?.value}">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path
                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                </svg>
                            </button>
                            <button (click)="setControls('documents','isTransportationProviderAgreementImage', true)"
                                [ngClass]="{'btn btn-success': approvalForm.get('documents.isTransportationProviderAgreementImage')?.value,
                                     'btn-outline btn-outline-success ': !approvalForm.get('documents.isTransportationProviderAgreementImage')?.value}"
                                class="px-2" type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path fill-rule="evenodd"
                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                        clip-rule="evenodd" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        W-9
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="w9Image" type="text" readonly />
                        </div>
                        <div class="flex gap-1">
                            <button (click)="setControls('documents','isW9Image', false)" class="px-2" type="button"
                                [ngClass]="{'btn btn-danger': !approvalForm.get('documents.isW9Image')?.value,
                                   'btn-outline btn-outline-danger': approvalForm.get('documents.isW9Image')?.value}">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path
                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                </svg>
                            </button>
                            <button (click)="setControls('documents','isW9Image', true)" [ngClass]="{'btn btn-success': approvalForm.get('documents.isW9Image')?.value,
                                 'btn-outline btn-outline-success ': !approvalForm.get('documents.isW9Image')?.value}"
                                class="px-2" type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path fill-rule="evenodd"
                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                        clip-rule="evenodd" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Disclosure of Ownership
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="disclosureofOwnershipImage" type="text" readonly />
                        </div>
                        <div class="flex gap-1">
                            <button (click)="setControls('documents','isDisclosureofOwnershipImage', false)"
                                class="px-2" type="button"
                                [ngClass]="{'btn btn-danger': !approvalForm.get('documents.isDisclosureofOwnershipImage')?.value,
                                  'btn-outline btn-outline-danger': approvalForm.get('documents.isDisclosureofOwnershipImage')?.value}">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path
                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                </svg>
                            </button>
                            <button (click)="setControls('documents','isDisclosureofOwnershipImage', true)"
                                [ngClass]="{'btn btn-success': approvalForm.get('documents.isDisclosureofOwnershipImage')?.value,
                                 'btn-outline btn-outline-success ': !approvalForm.get('documents.isDisclosureofOwnershipImage')?.value}" class="px-2" type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path fill-rule="evenodd"
                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                        clip-rule="evenodd" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        EFT Form
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="eFTFormImage" type="text" value="" readonly />
                        </div>
                        <div class="flex gap-1">
                            <button (click)="setControls('documents','isEFTFormImage', false)" class="px-2"
                                type="button"
                                [ngClass]="{'btn btn-danger': !approvalForm.get('documents.isEFTFormImage')?.value,
                                 'btn-outline btn-outline-danger': approvalForm.get('documents.isEFTFormImage')?.value}">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path
                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                </svg>
                            </button>
                            <button (click)="setControls('documents','isEFTFormImage', true)"
                                [ngClass]="{'btn btn-success': approvalForm.get('documents.isEFTFormImage')?.value,
                                 'btn-outline btn-outline-success ': !approvalForm.get('documents.isEFTFormImage')?.value}" class="px-2" type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path fill-rule="evenodd"
                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                        clip-rule="evenodd" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Voided Check
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="voidedCheckImage" type="text" readonly />
                        </div>
                        <div class="flex gap-1">
                            <button (click)="setControls('documents','isVoidedCheckImage', false)" class="px-2"
                                type="button"
                                [ngClass]="{'btn btn-danger': !approvalForm.get('documents.isVoidedCheckImage')?.value,
                                     'btn-outline btn-outline-danger': approvalForm.get('documents.isVoidedCheckImage')?.value}">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path
                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                </svg>
                            </button>
                            <button (click)="setControls('documents','isVoidedCheckImage', true)"
                                [ngClass]="{'btn btn-success': approvalForm.get('documents.isVoidedCheckImage')?.value,
                                    'btn-outline btn-outline-success ': !approvalForm.get('documents.isVoidedCheckImage')?.value}" class="px-2" type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path fill-rule="evenodd"
                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                        clip-rule="evenodd" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Vehicle Schedule
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="vehicleScheduleImage" type="text" value="" readonly />
                        </div>
                        <div class="flex gap-1">
                            <button (click)="setControls('documents','isVehicleScheduleImage', false)" class="px-2"
                                type="button"
                                [ngClass]="{'btn btn-danger': !approvalForm.get('documents.isVehicleScheduleImage')?.value,
                                     'btn-outline btn-outline-danger': approvalForm.get('documents.isVehicleScheduleImage')?.value}">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path
                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                </svg>
                            </button>
                            <button (click)="setControls('documents','isVehicleScheduleImage', true)"
                                [ngClass]="{'btn btn-success': approvalForm.get('documents.isVehicleScheduleImage')?.value,
                                  'btn-outline btn-outline-success ': !approvalForm.get('documents.isVehicleScheduleImage')?.value}" class="px-2" type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path fill-rule="evenodd"
                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                        clip-rule="evenodd" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Driver Schedule
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="driverScheduleImage" type="text" value="" readonly />
                        </div>
                        <div class="flex gap-1">
                            <button (click)="setControls('documents','isDriverScheduleImage', false)" class="px-2"
                                type="button"
                                [ngClass]="{'btn btn-danger': !approvalForm.get('documents.isDriverScheduleImage')?.value,
                                     'btn-outline btn-outline-danger': approvalForm.get('documents.isDriverScheduleImage')?.value}">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path
                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                </svg>
                            </button>
                            <button (click)="setControls('documents','isDriverScheduleImage', true)"
                                [ngClass]="{'btn btn-success': approvalForm.get('documents.isDriverScheduleImage')?.value,
                                  'btn-outline btn-outline-success ': !approvalForm.get('documents.isDriverScheduleImage')?.value}" class="px-2" type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path fill-rule="evenodd"
                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                        clip-rule="evenodd" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Vehicle For Hire License
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="vehicleForHireLicenseImage" type="text" value="" readonly />
                        </div>
                        <div class="flex gap-1">
                            <button (click)="setControls('documents','isVehicleForHireLicenseImage', false)"
                                class="px-2" type="button"
                                [ngClass]="{'btn btn-danger': !approvalForm.get('documents.isVehicleForHireLicenseImage')?.value,
                                    'btn-outline btn-outline-danger': approvalForm.get('documents.isVehicleForHireLicenseImage')?.value}">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path
                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                </svg>
                            </button>
                            <button (click)="setControls('documents','isVehicleForHireLicenseImage', true)"
                                [ngClass]="{'btn btn-success': approvalForm.get('documents.isVehicleForHireLicenseImage')?.value,
                                  'btn-outline btn-outline-success ': !approvalForm.get('documents.isVehicleForHireLicenseImage')?.value}" class="px-2" type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path fill-rule="evenodd"
                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                        clip-rule="evenodd" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </ng-container>
        </section>
        <div class="mt-4">
            <h2 class="heading">
                Insurance Information
            </h2>
            <p class="text-sm-light">
                (Read Only)
            </p>
        </div>
        <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
        <section class="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
            <ng-container formGroupName="insurance">
                <div class="space-y-1">
                    <label class="subheading">
                        General Liability Insurance
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="generalLiabilityInsuranceImage" type="text" readonly />
                        </div>
                        <div class="flex gap-1">
                            <button (click)="setControls('insurance','isGeneralLiabilityInsuranceImage', false)"
                                class="px-2" type="button"
                                [ngClass]="{'btn btn-danger': !approvalForm.get('insurance.isGeneralLiabilityInsuranceImage')?.value,
                                        'btn-outline btn-outline-danger': approvalForm.get('insurance.isGeneralLiabilityInsuranceImage')?.value}">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path
                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                </svg>
                            </button>
                            <button (click)="setControls('insurance','isGeneralLiabilityInsuranceImage', true)"
                                [ngClass]="{'btn btn-success': approvalForm.get('insurance.isGeneralLiabilityInsuranceImage')?.value,
                                     'btn-outline btn-outline-success ': !approvalForm.get('insurance.isGeneralLiabilityInsuranceImage')?.value}"
                                class="px-2" type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path fill-rule="evenodd"
                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                        clip-rule="evenodd" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        General Liability Expiry Date
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="generalLiabilityInsuranceDate" type="text" value="" readonly />
                        </div>
                        <div class="flex gap-1">
                            <button (click)="setControls('insurance','isGeneralLiabilityInsuranceDate', false)"
                                class="px-2" type="button"
                                [ngClass]="{'btn btn-danger': !approvalForm.get('insurance.isGeneralLiabilityInsuranceDate')?.value,
                                             'btn-outline btn-outline-danger': approvalForm.get('insurance.isGeneralLiabilityInsuranceDate')?.value}">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path
                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                </svg>
                            </button>
                            <button (click)="setControls('insurance','isGeneralLiabilityInsuranceDate', true)"
                                [ngClass]="{'btn btn-success': approvalForm.get('insurance.isGeneralLiabilityInsuranceDate')?.value,
                                         'btn-outline btn-outline-success ': !approvalForm.get('insurance.isGeneralLiabilityInsuranceDate')?.value}"
                                class="px-2" type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path fill-rule="evenodd"
                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                        clip-rule="evenodd" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Auto Liability Insurance
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="autoLiabilityInsuranceImage" type="text" value="" readonly />
                        </div>
                        <div class="flex gap-1">
                            <button (click)="setControls('insurance','isAutoLiabilityInsuranceImage', false)"
                                class="px-2" type="button"
                                [ngClass]="{'btn btn-danger': !approvalForm.get('insurance.isAutoLiabilityInsuranceImage')?.value,
                                      'btn-outline btn-outline-danger': approvalForm.get('insurance.isAutoLiabilityInsuranceImage')?.value}">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path
                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                </svg>
                            </button>
                            <button (click)="setControls('insurance','isAutoLiabilityInsuranceImage', true)"
                                [ngClass]="{'btn btn-success': approvalForm.get('insurance.isAutoLiabilityInsuranceImage')?.value,
                                  'btn-outline btn-outline-success ': !approvalForm.get('insurance.isAutoLiabilityInsuranceImage')?.value}" class="px-2" type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path fill-rule="evenodd"
                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                        clip-rule="evenodd" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Auto Liability Expiry Date
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="autoLiabilityInsuranceDate" type="text" value="" readonly />
                        </div>
                        <div class="flex gap-1">
                            <button (click)="setControls('insurance','isAutoLiabilityInsuranceDate', false)"
                                class="px-2" type="button"
                                [ngClass]="{'btn btn-danger': !approvalForm.get('insurance.isAutoLiabilityInsuranceDate')?.value,
                               'btn-outline btn-outline-danger': approvalForm.get('insurance.isAutoLiabilityInsuranceDate')?.value}">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path
                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                </svg>
                            </button>
                            <button (click)="setControls('insurance','isAutoLiabilityInsuranceDate', true)"
                                [ngClass]="{'btn btn-success': approvalForm.get('insurance.isAutoLiabilityInsuranceDate')?.value,
                                  'btn-outline btn-outline-success ': !approvalForm.get('insurance.isAutoLiabilityInsuranceDate')?.value}" class="px-2" type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path fill-rule="evenodd"
                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                        clip-rule="evenodd" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                  <div class="space-y-1">
                    <label class="subheading">
                         COI For Worker Compensation 
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="workerCOIImage" type="text" readonly />
                        </div>
                        <div class="flex gap-1">
                            <button (click)="setControls('insurance','isWorkerCOIImage', false)"
                                class="px-2" type="button"
                                [ngClass]="{'btn btn-danger': !approvalForm.get('insurance.isWorkerCOIImage')?.value,
                                        'btn-outline btn-outline-danger': approvalForm.get('insurance.isWorkerCOIImage')?.value}">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path
                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                </svg>
                            </button>
                            <button (click)="setControls('insurance','isWorkerCOIImage', true)"
                                [ngClass]="{'btn btn-success': approvalForm.get('insurance.isWorkerCOIImage')?.value,
                                     'btn-outline btn-outline-success ': !approvalForm.get('insurance.isWorkerCOIImage')?.value}"
                                class="px-2" type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path fill-rule="evenodd"
                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                        clip-rule="evenodd" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        COI For Worker Compensation Expiry Date
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="workerCOIImageExpireDate" type="text" value="" readonly />
                        </div>
                        <div class="flex gap-1">
                            <button (click)="setControls('insurance','isWorkerCOIImageExpireDate', false)"
                                class="px-2" type="button"
                                [ngClass]="{'btn btn-danger': !approvalForm.get('insurance.isWorkerCOIImageExpireDate')?.value,
                                             'btn-outline btn-outline-danger': approvalForm.get('insurance.isWorkerCOIImageExpireDate')?.value}">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path
                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                </svg>
                            </button>
                            <button (click)="setControls('insurance','isWorkerCOIImageExpireDate', true)"
                                [ngClass]="{'btn btn-success': approvalForm.get('insurance.isWorkerCOIImageExpireDate')?.value,
                                         'btn-outline btn-outline-success ': !approvalForm.get('insurance.isWorkerCOIImageExpireDate')?.value}"
                                class="px-2" type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path fill-rule="evenodd"
                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                        clip-rule="evenodd" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>

            </ng-container>
        </section>
        <div class="mt-4">
            <h2 class="heading">
                Bank Information
            </h2>
            <p class="text-sm-light">
                (Read Only)
            </p>
        </div>
        <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
        <section class="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
            <ng-container formGroupName="bankDetails">
                <div class="space-y-1">
                    <label class="subheading">
                        Bank Name
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="name" type="text" readonly />
                        </div>
                        <div class="flex gap-1">
                            <button (click)="setControls('bankDetails','isName', false)" class="px-2" type="button"
                                [ngClass]="{'btn btn-danger': !approvalForm.get('bankDetails.isName')?.value,
                                'btn-outline btn-outline-danger': approvalForm.get('bankDetails.isName')?.value}">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path
                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                </svg>
                            </button>
                            <button (click)="setControls('bankDetails','isName', true)" [ngClass]="{'btn btn-success': approvalForm.get('bankDetails.isName')?.value,
                                 'btn-outline btn-outline-success ': !approvalForm.get('bankDetails.isName')?.value}"
                                class="px-2" type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path fill-rule="evenodd"
                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                        clip-rule="evenodd" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Account Number
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="accountNumber" type="text" readonly />
                        </div>
                        <div class="flex gap-1">
                            <button (click)="setControls('bankDetails','isAccountNumber', false)" class="px-2"
                                type="button"
                                [ngClass]="{'btn btn-danger': !approvalForm.get('bankDetails.isAccountNumber')?.value,
                              'btn-outline btn-outline-danger': approvalForm.get('bankDetails.isAccountNumber')?.value}">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path
                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                </svg>
                            </button>
                            <button (click)="setControls('bankDetails','isAccountNumber', true)"
                                [ngClass]="{'btn btn-success': approvalForm.get('bankDetails.isAccountNumber')?.value,
                             'btn-outline btn-outline-success ': !approvalForm.get('bankDetails.isAccountNumber')?.value}" class="px-2" type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path fill-rule="evenodd"
                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                        clip-rule="evenodd" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Routing Number
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="routingNumber" type="text" readonly />
                        </div>
                        <div class="flex gap-1">
                            <button (click)="setControls('bankDetails','isRoutingNumber', false)" class="px-2"
                                type="button"
                                [ngClass]="{'btn btn-danger': !approvalForm.get('bankDetails.isRoutingNumber')?.value,
                                 'btn-outline btn-outline-danger': approvalForm.get('bankDetails.isRoutingNumber')?.value}">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path
                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                </svg>
                            </button>
                            <button (click)="setControls('bankDetails','isRoutingNumber', true)"
                                [ngClass]="{'btn btn-success': approvalForm.get('bankDetails.isRoutingNumber')?.value,
                                     'btn-outline btn-outline-success ': !approvalForm.get('bankDetails.isRoutingNumber')?.value}" class="px-2" type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="size-5">
                                    <path fill-rule="evenodd"
                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                        clip-rule="evenodd" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </ng-container>
        </section>
        <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
        <section class="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
            <div class="space-y-1 col-span-full">
                <label class="subheading">
                    Following information are invalid and need to be resubmitted by the company.
                </label>
                <div class="flex flex-1 gap-2">
                    <button class="btn btn-primary">
                        Send Information via Email
                    </button>
                </div>
            </div>
        </section>
        <div class="mt-4">
            <h2 class="subheading">
                I have checked the information given and i hereby confirm that all data entered is valid and
                satisfactory for the purpose of compliance and billing of trip
            </h2>
        </div>
        <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
        <section class="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
            <div class="space-y-1">
                <label class="subheading">
                    Date
                </label>
                <div class="flex flex-1 gap-2">
                    <div class="flex-1">
                        <input type="date" />
                    </div>
                </div>
            </div>
            <div class="space-y-1">
                <label class="subheading">
                    User
                </label>
                <div class="flex flex-1 gap-2">
                    <div class="flex-1">
                        <select name="" id="">
                            <option value="">-- Select User --</option>
                        </select>
                    </div>
                </div>
            </div>
        </section>
        <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
        <section class="flex justify-end gap-4">
            <button type="submit" class="btn-outline btn-outline-secondary">
                Approve
            </button>
            <button type="button" class="btn btn-secondary">
                Send Contract
            </button>
        </section>
    </form>
</div>
</div>